import Bowser from 'bowser';

const useIsOutdatedBrowser = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserInfo = browser.getBrowser();

    const supportedBrowsers = {
        Chrome: 140, // https://developer.chrome.com/release-notes?hl=nl
        Firefox: 133, // https://www.mozilla.org/en-US/firefox/releases/
        Safari: 18, // https://developer.apple.com/documentation/safari-release-notes
        'Microsoft Edge': 140, // https://learn.microsoft.com/en-us/deployedge/microsoft-edge-relnote-archive-stable-channel
    };

    const isOutdated = () => {
        const name = browserInfo.name;
        const version = parseInt(browserInfo.version || '0');
        const minVersion = supportedBrowsers[name as keyof typeof supportedBrowsers];
        return version < minVersion;
    };

    return isOutdated();
};

export default useIsOutdatedBrowser;
